import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
import DashboardView from '../views/DashboardView.vue'
import LoginView from '../views/LoginView.vue'
import TaskView from '../views/TaskView.vue'
import Object1View from '../views/Object1View.vue'
import AccountView from '../views/AccountView.vue'
import RegisterView from '../views/RegisterView.vue'
import TaskListView from '../views/TaskListView.vue'
import Object1ListView from '../views/Object1ListView.vue'
import MessageListView from '../views/MessageListView.vue'
import TaskCreationView from '../views/TaskCreationView.vue'
import store from '../store/index.js'

const routes = [
  {
    path: '/dashboard',
    name: 'home',
    component: DashboardView,
    meta: { title: 'Home' }
  }, {
    path: '/login',
    component: LoginView,
    meta: { title: 'Login' }
  }, {
    path: '/account',
    component: AccountView,
    meta: { title: 'Account' }
  }, {
    path: '/tasks',
    component: TaskListView,
    meta: { title: 'Tasks' }
  }, {
    path: '/tasks/:id',
    component: TaskView,
    meta: { title: 'Task' },
    props: true
  },
  {
    path: '/create/task',
    component: TaskCreationView,
    meta: { title: 'New task' },
    props: true
  }, {
    path: '/messages',
    component: MessageListView,
    meta: { title: 'Messages' },
    props: true
  }, {
    path: '/objects',
    component: Object1ListView,
    meta: { title: 'Sites' },
    props: true
  }, {
    path: '/objects/:id',
    component: Object1View,
    meta: { title: 'Site' },
    props: true
  }, {
    path: '/register',
    component: RegisterView
  },
  {
    path: '/reset',
    component: RegisterView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  nextTick(() => {
    document.title = to.meta.title || window.apiConfig.SITENAME
  })
})

function LoadStyling () {
  const bodyStyles = document.body.style
  // bodyStyles.setProperty('--transition', 'none !important')
  for (const [key, value] of Object.entries(window.apiConfig.STYLING)) {
    bodyStyles.setProperty(key, value)
  }
}

router.beforeEach(async (to, from, next) => {
  /**
   * Might be some issue with logic here but we check against the api
   * trying to find current user and then check if we still have
   */

  if (!window.apiConfig) {
    const timestamp = new Date().getTime() // Generates a unique timestamp
    const response = await fetch(`${process.env.BASE_URL}config.json?v=${timestamp}`)
    const config = await response.json()
    // console.log(config)
    window.apiConfig = config
  }
  LoadStyling()
  const isAuthenticated = localStorage.getItem('token')
  if (isAuthenticated) {
    const now = new Date()
    const ticks = ((now.getTime() * 10000) + 621355968000000000)
    if (!localStorage.getItem('tokenExpiryDateInTicks') || parseInt(localStorage.getItem('tokenExpiryDateInTicks')) < ticks) {
      location.reload()
      localStorage.clear('token')
      localStorage.clear('tokenExpiryDateInTicks')
    }
    store.dispatch('login/startCounterOnRefresh')
    store.dispatch('sidebar/setLogin')
    store.dispatch('message/getBaseData')
  }

  // Define public pages
  const publicPages = ['/login', '/register', '/reset'] //, '/register', '/reset'
  // Check if we require authentication on page we try to access (to.path)
  const authRequired = !publicPages.includes(to.path)

  if (authRequired && !isAuthenticated) {
    localStorage.setItem('attemptedRoute', to.path)
    // Authentication check failed reroute to login
    next('login')
  } else if (to.path === '/') {
    next('dashboard')
  } else if (isAuthenticated && to.path === '/login') {
    // Authentication if trying to access login page while loged in, reroute to home ('')
    next('dashboard')
  } else {
    // Allow page we try to access!
    next()
  }
})
export default router
